module.exports = __webpack_public_path__ + "static/media/mix.acb1833e.png";